<div class="joined-syndicate-wrapper">
  <p class="success-msg">
    {{ "joined-syndicate.Joined" | translate }}<br />
    {{ "joined-syndicate.Successfully" | translate }}
  </p>
  <p class="joined-label">
    {{ "joined-syndicate.You" | translate }} {{ data.lines }} {{ "joined-syndicate.for" | translate }}
    {{ data.productName }}
    @if(data.current_draw_day){
    (
      {{'dynamic_value.' + data.current_draw_day | translate }}
    )
    }@else{
      (
      @for (day of data.draw_day; track day; let i = $index) {
        {{'dynamic_value.' + day.trim() | translate}}
        @if (i < (data?.draw_day?.length - 1)) {
          <span>,</span>
        }
      }
        )<br />
    }
      <!-- {{'joined-syndicate.Syndicate' | translate}} {{data.syndicate_name ? data.syndicate_name : 'ABCC'}} -->
    </p>
    <div class="lottie-container ion-text-center">
      <ng-lottie [options]="{ path: '../../../assets/lotti_animation/join_syndicate_pop_up_animation/Clover.json' }">
      </ng-lottie>
    </div>
    <ion-button class="view-btn" (click)="viewTickets();startSpinner()">
      @if (!spinnerAnimation && proceed) {
        <span>{{'joined-syndicate.View' | translate}}</span>
      }
      @if (spinnerAnimation) {
        <div class="spinners">
          <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
          </mat-progress-spinner>
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
          </mat-progress-spinner>
        </div>
      }
      @if (!proceed) {
        <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
      }
    </ion-button>
    <p class="close" (click)="close()">{{ "joined-syndicate.Close" | translate }}</p>
  </div>
